import { render, staticRenderFns } from "./form_add_products_component.vue?vue&type=template&id=5c3dfcd6&scoped=true"
import script from "./form_add_products_component.vue?vue&type=script&lang=js"
export * from "./form_add_products_component.vue?vue&type=script&lang=js"
import style0 from "./form_add_products_component.vue?vue&type=style&index=0&id=5c3dfcd6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3dfcd6",
  null
  
)

export default component.exports